import { render, staticRenderFns } from "./bbslist.vue?vue&type=template&id=0068d602&scoped=true&"
import script from "./bbslist.vue?vue&type=script&lang=js&"
export * from "./bbslist.vue?vue&type=script&lang=js&"
import style0 from "./bbslist.vue?vue&type=style&index=0&id=0068d602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0068d602",
  null
  
)

export default component.exports